import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de pas - Calculer les pas de marche quotidiens pour perdre du poids avec précision";
const DESCRIPTION =
  "Calculatrice de pas - Calculer les pas de marche quotidiens pour perdre du poids avec précision en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de pas r les pas de marche quotidiens pour perdre du poids avec précision, calculatrice de pas r les pas de marche quotidiens pour perdre du poids avec précision, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/walking-calories/";

function WalkingCalorieCalculator() {
  const [weight, setWeight] = useState("");
  const [sex, setSex] = useState("male");
  const [slope, setSlope] = useState("0");
  const [steps, setSteps] = useState("");
  const [distance, setDistance] = useState("");
  const [time, setTime] = useState({ hours: "", minutes: "" });
  const [speed, setSpeed] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateCalories = () => {
    try {
      setError("");
      if (!weight) {
        throw new Error("Veuillez entrer le poids");
      }
      const weightKg = parseFloat(weight);
      const slopePercent = parseFloat(slope);
      const stepsCount = steps ? parseFloat(steps) : null;
      const distanceKm = distance ? parseFloat(distance) : null;
      const speedKmh = speed ? parseFloat(speed) : null;
      const hours = time.hours ? parseFloat(time.hours) : 0;
      const minutes = time.minutes ? parseFloat(time.minutes) : 0;

      if (weightKg <= 0) {
        throw new Error("Le poids doit être supérieur à zéro");
      }

      let calculatedDistance = distanceKm;
      let calculatedTime = hours + (minutes / 60);
      let calculatedSpeed = speedKmh;

      if (stepsCount && !distanceKm) {
        calculatedDistance = stepsCount * 0.762 / 1000;
      }
      if (calculatedDistance && calculatedTime && !speedKmh) {
        calculatedSpeed = calculatedDistance / calculatedTime;
      } else if (calculatedDistance && speedKmh && !calculatedTime) {
        calculatedTime = calculatedDistance / speedKmh;
      } else if (speedKmh && calculatedTime && !calculatedDistance) {
        calculatedDistance = speedKmh * calculatedTime;
      }

      let met;
      if (calculatedSpeed) {
        if (calculatedSpeed < 3.2) met = 2.0;
        else if (calculatedSpeed < 4.8) met = 2.8;
        else if (calculatedSpeed < 6.4) met = 3.5;
        else met = 5.0;
        met += Math.abs(slopePercent) * 0.1;
        if (slopePercent > 0) met *= 1.2;
        if (slopePercent < 0) met *= 0.8;
      } else {
        met = 3.5;
      }

      const caloriesBurned = met * weightKg * calculatedTime;
      const weightLost = caloriesBurned / 7700;

      setResult({
        caloriesBurned: caloriesBurned.toFixed(2),
        weightLost: weightLost.toFixed(4),
        distance: calculatedDistance ? calculatedDistance.toFixed(2) : null,
        time: calculatedTime.toFixed(2),
        speed: calculatedSpeed ? calculatedSpeed.toFixed(2) : null
      });
    } catch (error) {
      setError(error.message);
    }
  };

  const resetCalculator = () => {
    setWeight("");
    setSex("male");
    setSlope("0");
    setSteps("");
    setDistance("");
    setTime({ hours: "", minutes: "" });
    setSpeed("");
    setResult(null);
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Calculez le nombre de calories brûlées lors de la marche et estimez votre perte de poids potentielle.
                  Entrez votre poids et les détails de votre marche pour obtenir des résultats précis.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label><strong>Poids (kg):</strong></label>
                    <input type="number" value={weight} onChange={(e) => setWeight(e.target.value)} className="form-control" placeholder="70" />
                  </div>
                  <div className="form-group">
                    <label><strong>Distance (km):</strong></label>
                    <input type="number" value={distance} onChange={(e) => setDistance(e.target.value)} className="form-control" placeholder="5" />
                  </div>
                  <div className="form-group">
                    <label><strong>Durée (heures:minutes):</strong></label>
                    <div className="row">
                      <div className="col-6">
                        <input type="number" value={time.hours} onChange={(e) => setTime({...time, hours: e.target.value})} className="form-control" placeholder="Heures" />
                      </div>
                      <div className="col-6">
                        <input type="number" value={time.minutes} onChange={(e) => setTime({...time, minutes: e.target.value})} className="form-control" placeholder="Minutes" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <button onClick={calculateCalories} className="btn btn-success flex-grow-1">Calculer</button>
                    <button onClick={resetCalculator} className="btn btn-secondary">Réinitialiser</button>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                {result && (
                  <div className="bg-light p-3 rounded">
                    <h3>Résultats</h3>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td><strong>Calories brûlées:</strong></td>
                          <td>{result.caloriesBurned} kcal</td>
                        </tr>
                        <tr>
                          <td><strong>Poids perdu estimé:</strong></td>
                          <td>{result.weightLost} kg</td>
                        </tr>
                        {result.distance && (
                          <tr>
                            <td><strong>Distance:</strong></td>
                            <td>{result.distance} km</td>
                          </tr>
                        )}
                        {result.speed && (
                          <tr>
                            <td><strong>Vitesse:</strong></td>
                            <td>{result.speed} km/h</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <SecondAds />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Calories brûlées en marchant</h3></div>
              <div className="info-section-body"><p>La marche est l'une des activités physiques les plus accessibles pour brûler des calories. Le nombre de calories brûlées dépend du poids, de la vitesse de marche, de la distance et du dénivelé. En moyenne, une personne de 70 kg brûle environ 60-70 calories par kilomètre parcouru.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Bienfaits de la marche</h3></div>
              <div className="info-section-body"><p>Marcher 30 minutes par jour réduit le risque de maladies cardiaques, améliore la santé mentale, renforce les os et aide à maintenir un poids sain. Les experts recommandent au minimum 150 minutes d'activité physique modérée par semaine, comme la marche rapide.</p></div>
            </div>
          </div>
          <RelatedLinks />
        </div>
      </div>
    </div>
  );
}

export default WalkingCalorieCalculator;
